import { render, staticRenderFns } from "./DeadCintilloPataDetail.vue?vue&type=template&id=4318579b&scoped=true"
import script from "./DeadCintilloPataDetail.vue?vue&type=script&lang=js"
export * from "./DeadCintilloPataDetail.vue?vue&type=script&lang=js"
import style0 from "./DeadCintilloPataDetail.vue?vue&type=style&index=0&id=4318579b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318579b",
  null
  
)

export default component.exports